import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet5 = css`
  :host {

  }

  .image__facet-5 {
    ::slotted(img), ::slotted(picture) {
      object-fit: cover;
      clip-path: polygon( 22.3% 87.5%,4.45% 56.575%,4.45% 56.575%,3.728% 55.151%,3.166% 53.676%,2.765% 52.163%,2.524% 50.625%,2.444% 49.075%,2.524% 47.525%,2.765% 45.987%,3.166% 44.474%,3.728% 42.999%,4.45% 41.575%,17.975% 18.15%,17.975% 18.15%,18.844% 16.81%,19.838% 15.584%,20.947% 14.479%,22.159% 13.501%,23.463% 12.656%,24.847% 11.951%,26.302% 11.391%,27.816% 10.984%,29.377% 10.734%,30.975% 10.65%,66.675% 10.65%,94.85% 59.475%,94.85% 59.475%,95.754% 61.253%,96.455% 63.095%,96.955% 64.986%,97.253% 66.909%,97.35% 68.847%,97.246% 70.784%,96.941% 72.705%,96.436% 74.592%,95.73% 76.429%,94.825% 78.2%,94.825% 78.2%,94.825% 78.2%,93.738% 79.858%,92.497% 81.375%,91.116% 82.745%,89.608% 83.958%,87.988% 85.006%,86.268% 85.882%,84.463% 86.578%,82.587% 87.085%,80.653% 87.395%,78.675% 87.5%,22.3% 87.5% );
      aspect-ratio: 1;
      width: 100%;
        height: auto;
      z-index: 2;
    }
      .image-shapes-5 {
          display: block;
      }
      .image-shapes-5--crop-mobile {
          display: none;
      }
  }

    .image__facet-5--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            aspect-ratio:  4 / 3;
            clip-path: polygon( 71.115% 0%,18.25% 0%,18.25% 0%,18.068% 0.289%,17.889% 0.583%,17.714% 0.881%,17.543% 1.184%,17.376% 1.492%,17.212% 1.804%,17.053% 2.121%,16.898% 2.443%,16.747% 2.769%,16.6% 3.1%,2.343% 35.822%,2.343% 35.822%,1.579% 37.819%,0.985% 39.885%,0.561% 42.003%,0.306% 44.154%,0.221% 46.322%,0.306% 48.489%,0.561% 50.637%,0.985% 52.749%,1.579% 54.808%,2.343% 56.796%,21.146% 100.004%,80.566% 100.004%,80.566% 100.004%,82.65% 99.856%,84.687% 99.421%,86.664% 98.711%,88.565% 97.736%,90.376% 96.509%,92.083% 95.041%,93.67% 93.344%,95.123% 91.429%,96.428% 89.308%,97.57% 86.993%,97.57% 86.993%,98.52% 84.519%,99.261% 81.952%,99.791% 79.315%,100.112% 76.631%,100.221% 73.924%,100.119% 71.215%,99.806% 68.528%,99.282% 65.887%,98.545% 63.313%,97.596% 60.83%,71.115% 0% );
        }
        .image-shapes-5 {
            display: none;
        }
        .image-shapes-5--crop-mobile {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                clip-path: polygon( 22.3% 87.5%,4.45% 56.575%,4.45% 56.575%,3.728% 55.151%,3.166% 53.676%,2.765% 52.163%,2.524% 50.625%,2.444% 49.075%,2.524% 47.525%,2.765% 45.987%,3.166% 44.474%,3.728% 42.999%,4.45% 41.575%,17.975% 18.15%,17.975% 18.15%,18.844% 16.81%,19.838% 15.584%,20.947% 14.479%,22.159% 13.501%,23.463% 12.656%,24.847% 11.951%,26.302% 11.391%,27.816% 10.984%,29.377% 10.734%,30.975% 10.65%,66.675% 10.65%,94.85% 59.475%,94.85% 59.475%,95.754% 61.253%,96.455% 63.095%,96.955% 64.986%,97.253% 66.909%,97.35% 68.847%,97.246% 70.784%,96.941% 72.705%,96.436% 74.592%,95.73% 76.429%,94.825% 78.2%,94.825% 78.2%,94.825% 78.2%,93.738% 79.858%,92.497% 81.375%,91.116% 82.745%,89.608% 83.958%,87.988% 85.006%,86.268% 85.882%,84.463% 86.578%,82.587% 87.085%,80.653% 87.395%,78.675% 87.5%,22.3% 87.5% );
                aspect-ratio: 1;
            }
            .image-shapes-5 {
                display: block;
            }
            .image-shapes-5--crop-mobile {
                display: none;
            }
        }
    }

  .image-shapes-5 {
    position: absolute;
      top: 2.2%;
      left: -3.5%;
      width: 101%;
    height: auto;
    z-index: 3;
  }

    .image__facet-5--alternative .image-shapes-5 {
        top: 9%;
        left: -4%;
        width: 108.2%;
    }

    .image-shapes-5--crop-mobile {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 3;
    }
`;
